import { ConfirmDialog } from "@common/ConfirmDialog";
import { ComponentColor } from "@common/types";

interface ResendInvitationDialogProps {
    email: string;
    isProcessing: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

// Confirming kills the applicant's current link, so it asks first, on the
// shared ConfirmDialog chassis.
export const ResendInvitationDialog = ({
    email,
    isProcessing,
    onConfirm,
    onClose,
}: ResendInvitationDialogProps) => (
    <ConfirmDialog
        title={`Send a new signup link to ${email}?`}
        body="Any signup link sent earlier stops working."
        confirmLabel="Send new link"
        confirmColor={ComponentColor.Primary}
        isProcessing={isProcessing}
        onConfirm={onConfirm}
        onClose={onClose}
    />
);
